import { render, staticRenderFns } from "./JCheckbox.vue?vue&type=template&id=18ec6a30&"
import script from "./JCheckbox.vue?vue&type=script&lang=js&"
export * from "./JCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports